import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  inject,
} from '@angular/core';

import { ENV_TOKEN } from '@app/app.tokens';
import { Env } from '@app/core/interfaces/env.interface';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NotFoundPageComponent implements OnInit {
  private env = inject<Env>(ENV_TOKEN);

  ngOnInit(): void {
    window.location.href = this.env.site;
  }
}
